module.exports = __webpack_public_path__ + "static/media/silderItem4.3aa26f9c.JPG";